import { render, staticRenderFns } from "./TipTapEditor.vue?vue&type=template&id=73fefd3d&scoped=true&"
import script from "./TipTapEditor.vue?vue&type=script&lang=ts&"
export * from "./TipTapEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TipTapEditor.vue?vue&type=style&index=0&id=73fefd3d&scoped=true&lang=scss&"
import style1 from "./TipTapEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fefd3d",
  null
  
)

export default component.exports